import { stateOfLineage } from '@/components/fields/lineage'
import type { LoanFieldLineageField } from '@/pages/pipeline-intelligence/types'

/** What a figure with no document behind it offers on click, by its state. */
export const DETAIL_VERB: Partial<Record<string, string>> = {
  derived: 'is derived',
  suggested: 'is suggested',
  confirmed: 'was confirmed',
}

/**
 * Whether a request to open this field's source should show where the figure
 * comes from (a Derived value's formula and inputs, a Suggested value's
 * basis, who Confirmed it) instead of opening the document viewer.
 *
 * True when the lineage names the figure Derived, Suggested or Confirmed and
 * no document to open. The viewer matches a file by the lineage source, which
 * for these reads "derived: NOI / DSCR" or similar, so it found none and said
 * "The recorded source file is unavailable", as though a document had been
 * lost. With no lineage row the viewer keeps the request: nothing says the
 * figure is not a stated one.
 */
export function opensProvenanceNotDocument(row: LoanFieldLineageField | null | undefined): boolean {
  if (!row) return false
  if (!DETAIL_VERB[stateOfLineage(row)]) return false
  return !row.provenance?.document
}
